export default [
  {
    path: '/report/student-statistics',
    name: 'studentStatistic',
    meta: { requiresAuth: true },
    component: () => import('./views/index.vue')
  }
]
